import React, { useState } from "react";
import { ChevronRight } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Box,
  Button,
  Divider,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "assets/icons/closeButton.svg";
import DummyPhoto from "assets/icons/labmodal.png";
// import LeftCloseBarIcon from "assets/icons/leftCloseBarIcon.svg";
import "./AIAssistantDrawer.css";

const AIAssistantDrawer = ({ selectedAiRow, onClose }) => {
  const [expandedComment, setExpandedComment] = useState("comment-1");
  const tierLabel = String(selectedAiRow?.tier || "A");
  const tierPrefix = tierLabel.trim().charAt(0).toUpperCase() || "A";

  return (
    <Box className="ai-assistant-panel">
      {/* <img
        src={LeftCloseBarIcon}
        className="test-results-close-btn"
        onClick={onClose}
        alt="close"
      /> */}
      <Box className="ai-assistant-header">
        <Typography component="div" className="ai-assistant-title-pill">
          AI
        </Typography>
        <Box className="ai-assistant-header-actions">
          <img
            src={CloseIcon}
            className="close-test-results"
            onClick={onClose}
            alt="close"
          />
        </Box>
      </Box>
      <Box className="ai-assistant-content">
        <Box className="ai-context-box">
          <Box className="ai-row-summary">
            <Box className="ai-summary-chip ai-summary-tier">
              <Typography component="span" className="ai-tier-value">
                {tierPrefix}
              </Typography>
              <Typography component="span" className="ai-tier-text">
                Tier
              </Typography>
            </Box>
            <Box className="ai-summary-item">
              <Typography component="span">Room</Typography>
              <Typography component="p">
                {selectedAiRow?.room_name?.name || "-"}
              </Typography>
            </Box>
            <Box className="ai-summary-item">
              <Typography component="span">Sample Type</Typography>
              <Typography component="p">
                {selectedAiRow?.test?.name || "-"}
              </Typography>
            </Box>
            <Box className="ai-summary-item">
              <Typography component="span">Observation</Typography>
              <Typography component="p">
                {selectedAiRow?.observation?.name || "-"}
              </Typography>
            </Box>
            <Box
              className={`ai-summary-chip ai-summary-status ${selectedAiRow?.status ? "approved" : "unapproved"}`}
            >
              {selectedAiRow?.status ? "Approved" : "Unapproved"}
            </Box>
          </Box>
          <Divider className="ai-row-summary-divider" />

          <Box className="ai-section">
            <Typography variant="h4">Photos</Typography>
            <Box className="ai-photos-grid">
              {[1, 2, 3, 4].map((photo) => (
                <Box key={photo} className="ai-photo-thumb">
                  <img src={DummyPhoto} alt="dummy observation" />
                </Box>
              ))}
              <Box className="ai-photo-thumb ai-photo-more">+5 Photos</Box>
            </Box>
          </Box>

          <Box className="ai-section">
            <Typography variant="h4">Comments</Typography>
            <Box className="ai-comment-accordion">
              <Accordion
                expanded={expandedComment === "comment-1"}
                onChange={() =>
                  setExpandedComment((prev) =>
                    prev === "comment-1" ? "" : "comment-1"
                  )
                }
                disableGutters
                elevation={0}
                square
                className="ai-comment-card"
              >
                <AccordionSummary
                  className="ai-comment-toggle"
                  expandIcon={
                    <ChevronRight
                      className={`ai-chevron ${expandedComment === "comment-1" ? "expanded" : ""}`}
                    />
                  }
                >
                  <Typography component="h5">Comment 1</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography component="p">
                    {selectedAiRow?.sample_note || "No sample note available."}
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion
                expanded={expandedComment === "comment-2"}
                onChange={() =>
                  setExpandedComment((prev) =>
                    prev === "comment-2" ? "" : "comment-2"
                  )
                }
                disableGutters
                elevation={0}
                square
                className="ai-comment-card"
              >
                <AccordionSummary
                  className="ai-comment-toggle"
                  expandIcon={
                    <ChevronRight
                      className={`ai-chevron ${expandedComment === "comment-2" ? "expanded" : ""}`}
                    />
                  }
                >
                  <Typography component="h5">Comment 2</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography component="p">
                    {selectedAiRow?.result ||
                      "No additional comments available."}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Box>
          </Box>

          <Box className="ai-section">
            <Typography variant="h4">Reason</Typography>
            <Typography component="div" className="ai-reason-card">
              {selectedAiRow?.observation?.name ||
                "No reasoning data available for this sample."}
            </Typography>
          </Box>
        </Box>

        <Typography className="ai-analysis-title">Analysis</Typography>
        <Box className="ai-chat-wrap">
          <Box className="ai-chat-row ai">
            <Avatar className="ai-message-avatar">AI</Avatar>
            <Box className="ai-chat-bubble ai">
              Change the classification from Tier A to Tier B based on the
              current context.
            </Box>
          </Box>
          <Box className="ai-chat-row user">
            <Box className="ai-chat-bubble user">
              Reviewed the sample details for room
              <strong> {selectedAiRow?.room_name?.name || "-"}</strong> with
              observation
              <strong> {selectedAiRow?.observation?.name || "-"}</strong>. The
              recommendation can be added to your knowledge base.
            </Box>
            <Avatar className="ai-message-avatar user">U</Avatar>
          </Box>
          <Button type="button" className="ai-kb-btn">
            Add to Knowledge Base
          </Button>
        </Box>

        <Box className="ai-feedback">
          <TextField
            fullWidth
            variant="standard"
            placeholder="Enter Your Feedback..."
            InputProps={{ disableUnderline: true, readOnly: true }}
          />
          <IconButton type="button" aria-label="Send feedback">
            &gt;
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default AIAssistantDrawer;
